module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_10.e355d7ab.png";